import { render, staticRenderFns } from "./SgQuickSignup.vue?vue&type=template&id=7a9e5342&"
import script from "./SgQuickSignup.vue?vue&type=script&lang=js&"
export * from "./SgQuickSignup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports